import { isPatternGlyphKind, PatternGlyph, type PatternGlyphKind } from "./PatternGlyph";

export type MotifGlyphKind = "book" | "clock" | "flag" | "best" | "brilliant" | "check" | "text" | PatternGlyphKind;

export const MotifGlyph = ({ kind, label }: { kind: MotifGlyphKind; label: string }) => {
  if (isPatternGlyphKind(kind)) return <PatternGlyph motif={kind} />;
  if (kind === "book")
    return (
      <svg viewBox="0 0 24 24" width="78%" height="78%" aria-hidden>
        <path
          d="M3 5h6.2c1.25 0 2.2.55 2.8 1.4.6-.85 1.55-1.4 2.8-1.4H21v14h-6.2c-1.25 0-2.2.45-2.8 1.2-.6-.75-1.55-1.2-2.8-1.2H3Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M12 6.5V20M6 9h3.5M14.5 9H18M6 12h3.5M14.5 12H18"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    );
  if (kind === "clock")
    return (
      <svg viewBox="0 0 24 24" width="80%" height="80%" aria-hidden>
        <path
          d="M7 3h10M9 3v2m6-2v2M12 7v5l3 2"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="square"
        />
        <path d="M5 8h2V6h10v2h2v10h-2v2H7v-2H5Z" fill="none" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    );
  if (kind === "flag")
    return (
      <svg viewBox="0 0 24 24" width="80%" height="80%" aria-hidden>
        <path
          d="M6 21V3m1 1h11l-2.5 4L18 12H7"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="square"
          strokeLinejoin="miter"
        />
      </svg>
    );
  if (kind === "best")
    return (
      <svg viewBox="0 0 24 24" width="82%" height="82%" aria-hidden>
        <path d="m12 2 2.15 7.85L22 12l-7.85 2.15L12 22l-2.15-7.85L2 12l7.85-2.15Z" fill="currentColor" />
        <path d="m12 7 .8 4.2 4.2.8-4.2.8L12 17l-.8-4.2L7 12l4.2-.8Z" fill="#f0ece2" />
      </svg>
    );
  if (kind === "brilliant")
    return (
      <svg viewBox="0 0 24 24" width="84%" height="84%" aria-hidden>
        <path
          d="m9 3 1.15 5.85L16 10l-5.85 1.15L9 17l-1.15-5.85L2 10l5.85-1.15Zm8 8 .8 3.2L21 15l-3.2.8L17 19l-.8-3.2L13 15l3.2-.8Z"
          fill="currentColor"
        />
      </svg>
    );
  if (kind === "check")
    return (
      <svg viewBox="0 0 24 24" width="78%" height="78%" aria-hidden>
        <path
          d="m4 12 5 5L20 6"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="square"
          strokeLinejoin="miter"
        />
      </svg>
    );
  return <>{label}</>;
};
